export default {
  meta: {
    title: 'International Economic Forum of the Americas',
    description: `The International Economic Forum of the Americas (IEFA) encourages collaboration and innovation to address major global challenges.`
  },
  header: {
    message: "Connecting global business leaders to address the world's",
    span: 'major challenges'
  },
  graphic: '/images/brand/graphic-en.png',
  bullets: [
    {
      number: '23 200',
      label: 'Participants'
    },
    {
      number: '563',
      label: 'Speakers'
    },
    {
      number: '105',
      label: 'Reprensented\ncountries'
    },
    {
      number: '2 602',
      label: 'Bilateral\nmeetings'
    }
  ],
  testimonies: {
    title: 'Moments from our conferences',
    slides: [
      {
        content:
          'The war, which is absolutely dramatic, has really put at the forefront the notion of energy security.',
        name: 'Odile Renaud-Basso - President, European Bank for Reconstruction and Development (EBRD)',
        image: '/images/testimonials/OdileRenaud-Basso.jpg'
      },
      {
        content:
          'I look at the next 10-20 years in Québec, I think that there are two catalysts for the creation of value and wealth in Québec: the first is innovation, and the second is how we use our renewable energy resources.',
        name: 'Pierre Fitzgibbon - Minister of Economy, Innovation and Energy, National Assembly of Québec',
        image: '/images/testimonials/PierreFitzgibbon.jpg'
      },
      {
        content: 'We are at the hinge moment of history in economics and geopolitical history.',
        name:
          'Mark Carney - Vice Chair and Head of Transition Investing, Brookfield Asset Management; and United Nations Special Envoy for Climate Action and Finance',
        image: '/images/testimonials/MarkCarney.jpg'
      },
      {
        content:
          'The crisis and the challenge of the energy transition are very clear: it will take government, industry, and consumers al working together to achieve this change, but we cannot wait on each other.',
        name: 'Ivan Vella - Chief Executive, Aluminium, Rio Tinto',
        image: '/images/testimonials/IvanVella.jpg'
      },
      {
        content:
          'When we think about social engagement, when we think about social media, the ability to understand issues and to collectively organize around them, is accelerating.',
        name: 'Jean-Pierre Clamadieu - Chairman, ENGIE',
        image: '/images/testimonials/Jean-PierreClamadieu.jpg'
      }
    ]
  },
  about: {
    title: 'Our mission',
    content:
      'The International Economic Forum of the Americas (IEFA) was created in 1994 to encourage connection, collaboration and innovation in order to address the world’s major challenges. The organization leverages its extensive network to convene a series of annual events across the globe where heads of state and government, members of the business community and civil society, trade union leaders and academics – all of them experts in their respective fields – can meet and discuss their common objectives and ways to achieve them.'
  },
  boards: {
    upTitle: 'Annual Events',
    title: 'The boards',
    content:
      'Since its foundation in 1994, the IEFA has been surrounded by business leaders, international organizations, and other influential figures who continue to support its mission through various committees and councils. Please refer to the different committees to learn more about the individuals who support our mission.'
  },
  partner: {
    title: 'Become a',
    content:
      'The IEFA has spent the past three decades building a world-class, global network of thought leaders across government, business and academia. The organization’s unrivaled ability to foster connection and collaboration makes the IEFA a unique platform for its partners.',
    content2:
      'Partners and sponsors play a key role in the development and continued success of the IEFA. By becoming an official sponsor, partners are able to join a strategic network where decision makers can exchange and connect, enabling productive dialogues and long-term working relationships. The IEFA is committed to providing a rewarding and unparalleled experience for its stakeholders – an aim which has resulted in the return of multiple partners year on year.'
  },
  services: {
    title: 'IEFA Consulting',
    content:
      'In addition to its flagship conferences, the International Economic Forum of the Americas offers a variety of services for clients wishing to expand their strategic network or produce their own events.',
    entries: [
      {
        title: 'Event production',
        content:
          '<p>The Forum has evolved and grown over the past three decades to bring together more than 23,000 participants and 560 speakers annually across five conferences: the Conference of Montreal, the Toronto Global Forum, the World Strategic Forum, the Conference of Paris and the IEFA LatAm Forum.</p><p>Leveraging this expertise and the organization’s extensive network, the IEFA regularly organizes and manages external conferences and events worldwide. The IEFA can cost-effectively manage, coordinate and deliver a world-class events package specifically tailored to the client’s needs. From the development of speakers and content through to conference design, production and strategy, the IEFA aims to deliver a seamless, market-leading service which creates a significant impact for its clients.</p>'
      },
      {
        title: 'Roundtable Production',
        content:
          '<p>The IEFA produces a program of private Business Roundtable Meetings, whether in-person, virtual or hybrid, which run year-round and are independent of the annual conferences.</p><p>These meetings usually consist of around 25 individuals, primarily C-suite executives or government leaders from around the world. The exact format of the roundtable, from location, production, content and attendees, is tailored to each.</p>'
      },
      {
        title: 'Executive Networking Consulting',
        content:
          '<p>The IEFA has spent the past three decades building an extensive network of thought leaders including world leaders, C-suite executives and academics across a wide array of fields. The organization is known for its ability to foster connections and collaboration in order to address the world’s most pressing challenges, specifically tailoring its audiences to achieve this goal. Depending on a client’s objectives, the IEFA can facilitate a series of private one-on-one meetings and introductions designed to create maximum impact.</p>'
      }
    ]
  },
  contact: {
    title: 'Contact us',
    content: 'To contact the IEFA, please complete the form. Someone will get back to you as soon as possible.',
    content2:
      'For media enquiries, please contact Rebecca Durnin, Director of Communications & Marketing, on r.durnin@forum-americas.org.'
  },
  newsletter: 'Subscribe to our newsletter'
}
